import { Inject } from '@odinjs/odin';

import { Endpoint, FOUNDATION_ROUTES, Route } from '@philips-emr/hpms-provider-accreditation-commons';
import { PanelAPI, TextAPI } from '@philips-emr/tws-components';
import { ButtonTheme, ModalButtonType } from '@philips-emr/tws-constants';
import Controller, { OnClick, OnMount } from '@philips-emr/tws-core/lib/client';
import { MountEvent } from '@philips-emr/tws-core/lib/component/types';
import { AuthenticationService, HttpService, ModalButton, ModalProps, ModalService, msg } from '@philips-emr/tws-core/lib/services';
import { format } from '@philips-emr/tws-core/lib/services/model-service';
import { applicationContext } from '@philips-emr/tws-foundation/lib/context';
import { isEmptyOrBlankString } from '@philips-emr/tws-utils';

import { MyDataAliases as Aliases, FragmentNames } from '../codegen';

import BaseController from './BaseController';

interface User {
  name: string;
  cdPhysicalPerson: string;
  dsEmail: string;
  dtLastAccess: string;
}

@Controller({ fragment: FragmentNames.MY_DATA })
export default class HomeController extends BaseController {

  @Inject(Aliases.TEXT_LAST_ACCESS)
  private lastAccessText!: TextAPI;

  @OnClick(Aliases.LINK_CHANGE_PW)
  onClickChangePassword(): void {
    this.historyService.push(Route.CHANGE_PW);
  }

  @OnClick(Aliases.LINK_PRIVACY)
  onClickPrivacy(): void {
    applicationContext.redirect(Route.PRIVACY, { });
  }

  @OnMount(Aliases.PANEL_LAST_ACCESS)
  public onMountPanelLastAccess(event: MountEvent): void {
    const api = event.target as unknown as PanelAPI;
    const setVisibility = (visibility: boolean): void => api.setVisible(visibility);
    const { nrSeqUser } = this.historyService.getCurrentRouteParams();

    void HttpService.get<User>(Endpoint.GET.MY_DATA_USER, { nrSeqUser })
      .then(({ body: user }) => {
        let visibility = false;

        if (user && !isEmptyOrBlankString(user.dtLastAccess)) {
          visibility = true;

          const message = msg('pa.hello-user-last-access')
            .replace('#@NM_USUARIO#@', user.name)
            .replace('#@DT_ULTIMO_ACESSO#@', format('date', user.dtLastAccess, { type: 'timestamp' }));

          this.lastAccessText.setValue(message);
        }

        setVisibility(visibility);
      }).catch(() => setVisibility(false));
  }

  @OnClick(Aliases.LINK_CLOSE_MY_ACCOUNT)
  onClickCloseAccount(): void {
    ModalService.openDialog(this.newModalDefaultContent());
  }

  private newModalDefaultContent(): ModalProps {
    const modalDefaultContent: ModalProps = {
      closeable: false,
      dialogDescription: 'pa.confirm-delete-account',
      dockButtons: this.newDockButtons(),
      title: 'pa.attention',
    };

    return modalDefaultContent;
  }

  private newDockButtons(): ModalButton[] {

    const onOk = (): void => {
      const { nrSeqUser } = this.historyService.getCurrentRouteParams();
      void HttpService.post(Endpoint.POST.CLOSE_ACCOUNT, { nrSeqUser })
        .then(() => {
          void AuthenticationService.logout();
          applicationContext.redirect(FOUNDATION_ROUTES.LOGIN);
        });
    };

    const onCancel = (): void => {
      return;
    };

    const dockButtons: ModalButton[] = [
      {
        action: onCancel,
        theme: ButtonTheme.SECONDARY,
        title: 'pa.cancel',
        type: ModalButtonType.CANCEL,
      },
      {
        action: onOk,
        title: 'pa.yes-string',
        type: ModalButtonType.SUCCESS,
      },
    ];

    return dockButtons;
  }

}

